export const DS_API_URL = 'https://secure.digitalsignage.com/';
